module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/cms-panel-active.c8b37189.svg";